module.exports = __webpack_public_path__ + "static/img/act-steps-m-4.24239b7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/act-steps-m-4.png
// module id = sic0
// module chunks = 1